// TODO: delete this file when is not in use anymore (when the form is migrated to Formik).
// For now is still used to make validations, but not to render the form.
export const InsurancePlanConfig = [
  {
    id: "insurance_id",
    label: "Insurance Id",
    dataKey: "insurance_id",
    cols: 12,
    required: true,
    hide: true,
  },
  {
    id: "id",
    label: "Insurance Id",
    dataKey: "id",
    cols: 12,
    hide: true,
  },
  {
    id: "insurance_name",
    label: "Insurance Company",
    dataKey: "insurance_name",
    cols: 12,
  },
  {
    id: "contract_type",
    label: "Contract Type",
    dataKey: "contract_type",
    catalog: true,
    cols: 12,
    divider: true,
  },
  {
    id: "name",
    label: "Name of Plan",
    dataKey: "name",
    cols: 12,
    required: true,
  },
  {
    id: "coverage_state",
    label: "Coverage State",
    dataKey: "coverage_state",
    cols: 12,
    required: true,
  },
  {
    id: "is_medicaid",
    label: "Medicaid Plan",
    dataKey: "is_medicaid",
    cols: 12,
    type: "yes_no",
  },
  {
    id: "eh_payer_id",
    dataKey: "eh_payer_id",
    required: false,
  },
  {
    id: "silna_payor_uuid",
    dataKey: "silna_payor_uuid",
    required: true,
  },
  {
    id: "candid_payer_id",
    dataKey: "candid_payer_id",
    required: true,
  },
  {
    id: "phone",
    label: "Phone Number",
    dataKey: "phone",
    cols: 12,
    required: true,
  },
  {
    id: "address_1",
    label: "Address",
    dataKey: "address_1",
    cols: 12,
    required: true,
  },
  {
    id: "address_2",
    label: "Address 2",
    dataKey: "address_2",
    cols: 12,
    required: false,
  },
  {
    id: "state",
    label: "State",
    dataKey: "state",
    cols: 12,
    required: true,
  },
  {
    id: "city",
    label: "City",
    dataKey: "city",
    cols: 12,
    required: true,
  },
  {
    id: "zip",
    label: "ZIP Code",
    dataKey: "zip",
    cols: 12,
    required: true,
    divider: true,
  },
];
